//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AlertComponent from 'app_components/commons/alert'
import CircleComponent from 'app_components/commons/circle'
import DataTableComponent from 'app_components/commons/dataTable'
import ActivityDetailsSkeleton from './activityDetailsSkeleton'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import {IActivityDetailTags} from 'app_types/campus/academic/activityDetailsTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../activityDetailsModule.scss'
import { useSelector } from 'react-redux';
import { CombinedReducers } from '../../../../../../events/index';

const webexIcon = require('assets/images/favicons/webex.svg');

// @ADD Component types
interface IActivityDetailsModuleLayoutProps {
  status: null | 'loading' | 'error'
  activityData: Array<any>
  pagination: IPagination
  // onPageChange: (page: number) => void
  tags: Array<IActivityDetailTags>
}

const ActivityDetailsModuleLayout: React.FC<IActivityDetailsModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const courseSelected = useSelector((store: CombinedReducers) => store?.courses?.courseSelected)

  return(
    <div className='activity_details-component'>
      <div className="title">
        {t("modules.activity_details.title")}
      </div>
      <hr />
      <div className="main-table">
        {props.status === 'loading' ? (
          <ActivityDetailsSkeleton />
        ): (
          <>
          {props.activityData && Array.isArray(props.activityData) && props.activityData.length > 0 ? (
            <>
            <div className="tag-list">
              {props.tags.map((tag) => (
                <span key={tag.key}>
                  <CircleComponent size={'15px'} color={tag.color}  />
                  {tag.label}
                </span>
              ))}
            </div>

            <DataTableComponent
              data={props.activityData}
              textAlign='left'
              headerKeys={[
                `${t('modules.activity_details.headers.position')}`,
                `${t('modules.activity_details.headers.activity')}`,
                `${t('modules.activity_details.headers.start_date')}`,
                `${t('modules.activity_details.headers.limit_date')}`,
                `${t('modules.activity_details.headers.delivery_date')}`,
                `${t('modules.activity_details.headers.event_type')}`,
                `${t('modules.activity_details.headers.join')}`,
              ]}
              keys={['position', 'activity', 'start_date', 'limit_date', 'delivery_date', 'circle_component', 'component_render_actions']}
              // pagination={props.pagination}
              detailsKey={[]}
              // onPageChange={props.onPageChange}
              onModal={null}
            />
            </>
          ): (
            <AlertComponent
              type='warning'
              title={t('modules.activity_details.no_data')}
            />
          )}
          </>
        )}
        {courseSelected?.schedulingMode?.name === 'Virtual' ?
          <AlertComponent
            type='info'
            description={(
              <div>
                Para los encuentros sincrónicos revise las fechas de citación publicadas por el tutor en el recurso de Webex
                <img src={webexIcon} style={{ width: '20px', height: '20px', margin: '0px 8px' }} alt="" />
                dentro del curso.
              </div>
            )}
          />
        :null}
      </div>
    </div>
  )
}

export default ActivityDetailsModuleLayout
